import { render } from "./mode1.vue?vue&type=template&id=5630852e&scoped=true"
import script from "./mode1.vue?vue&type=script&lang=js"
export * from "./mode1.vue?vue&type=script&lang=js"

import "./mode1.vue?vue&type=style&index=0&id=5630852e&lang=scss&scoped=true"

import exportComponent from "F:\\project\\2023\\山东博物馆大屏\\shandong\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5630852e"]])

export default __exports__